// extracted by mini-css-extract-plugin
export default {"LoginButton":"LoginButton_CTVto","LoginButton--package":"LoginButton--package_k7CfL"};